module.exports = __webpack_public_path__ + "img/BAU_Partners_7.9c314427.jpg";